import { Inject, Injectable } from '@angular/core';
import { VendorGroup } from '../models/vendorGroup.model';
import { ENV, IEnvironment } from 'env/config';
import { Observable } from 'rxjs';

import { DataService } from '../http/dataService';
import { CentralApis } from '../interfaces/internal';
import { IValue, Value } from '../models/value.model';
import { Repository } from './repository';
import { Result } from '../interfaces/helpers';

import { Service } from '../entity';
import { map } from 'rxjs/operators';

@Service({
  api: 'picklistvalue',
  model: Value,
})
@Injectable({ providedIn: 'root' })
export class ValueService extends Repository<Value> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: (env.api.backend.central.endpoint as CentralApis).appConfig,
    });
  }

  getAll(queryParams?: any): Observable<Result<Value>> {
    return super.getAll(queryParams);
  }

  createFromDTO(item: IValue): Value {
    return Value.createFromDTO(item);
  }
}
